import {Component , OnInit} from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {UserService} from "../../../core/services/users.service";
import {FuseConfigService} from '../../../core/services/config.service';
import { EventService } from '../../../core/services/event.service';

@Component({
    selector: 'statistic-page',
    templateUrl: './statistic.component.html',
    styleUrls: ['./statistic.component.scss'],
    standalone: false
})
export class StatisticComponent implements OnInit {

  view: any[];
  colorScheme: any;
  animations: boolean = true;
  dataNumber = [];
  public chartType2: string = 'doughnut';

  public chartDatasets2: Array<any> = [
    {
      data: [] , label: 'Target Group'
    }
  ];

  public chartLabels2: Array<any> = [];

  public chartColors2: Array<any> = [
    {
      backgroundColor: [ '#F0E68C' , '#F4A460' , '#FFEFD5' , '#F08080' , '#008000' , '#556B2F' , '#7B68EE' , '#FFE4B5' , '#FAFAD2' , '#FFD700' , '#FA8072' ,
                         '#66CDAA' , '#00CED1' , '#FFA500' , '#E6E6FA' , '#D2B48C' , '#6495ED' , '#7FFFD4' , '#BDB76B' , '#A9A9A9' , '#FFF8DC' , '#008080' , '#778899' , '#B0C4DE' ] ,
      hoverBackgroundColor: [ '#c6bd73' , '#F4A460' , '#FFEFD5' , '#F08080' , '#008000' , '#556B2F' , '#7B68EE' , '#FFE4B5' , '#FAFAD2' , '#FFD700' , '#FA8072' ,
                              '#66CDAA' , '#00CED1' , '#FFA500' , '#E6E6FA' , '#D2B48C' , '#6495ED' , '#7FFFD4' , '#BDB76B' , '#A9A9A9' , '#FFF8DC' , '#008080' , '#778899' , '#B0C4DE' ] ,
      borderWidth: 2 ,
    }
  ];
  public chartOptions2: any = {
    responsive: true
  };
  data;
  dataTG = [];
  dataEventType = [];
  dataUsers = [ [] , [] , [] , [] ];
  dataEvents = [ [] , [] , [] , [] ];
  eventTypeColor = {
    domain: [] , name: 'coolthree' ,
    selectable: true ,
    group: 'Ordinal'
  };
  organizations = [ {name: 'All' , id: ''} ];
  orgId = '';
  isTime = true;

  treemap = [];
  colorSchemeTree = {
    domain: [] , name: 'coolthree' ,
    selectable: true ,
    group: 'Ordinal'
  };
  subscription;
  communication;
  rewards;
  statuses;
  cooperationCount = 0;
  constructor (public userService: UserService,
               public eventService: EventService) {
    this.userService.getOrganization().subscribe((res: any) => {
      this.organizations = this.organizations.concat(res);
    });
    this.getData();
    this.getEventsInfo();
    this.getSubscription();
    this.getCommunications();
    this.getListRewads();
    this.getListStatuses();
  }

  getImage(name) {
    return this.eventService.getFileStream(name);
  }

  getListStatuses () {
    this.userService.getStatusDashboardInfo(this.orgId , this.isTime).subscribe((res: any) => {
      this.statuses = res.status;
    });
  }

  getListRewads () {
    this.userService.getRewardsDashboardInfo(this.orgId , this.isTime).subscribe((res: any) => {
      this.rewards = res.reward;
    });
  }

  ngOnInit () {
  }

  getEventsInfo () {
    this.userService.getEventsDashboardInfo(this.orgId , this.isTime).subscribe((res: any) => {
      this.treemap = [];
      this.treemap = this.sortData(res.event);
      this.treemap = this.treemap.filter((thing, index) => {
        return index === this.treemap.findIndex(obj => {
          return JSON.stringify(obj) === JSON.stringify(thing);
        });
      });
      if (this.treemap.length > 10) {
        this.treemap = this.treemap.slice(0, 10);
      }
      this.colorSchemeTree.domain = [];
      for (let i = 0; i < this.treemap.length; i++) {
        this.colorSchemeTree.domain.push(this.treemap[ i ].color);
      }
      console.log(this.treemap);
      console.log(this.colorSchemeTree);
    });

  }

  getSubscription () {
    this.userService.getSubscriptionsDashboardInfo(this.orgId , this.isTime).subscribe((res: any) => {
      this.subscription = [];
      for (let property in res.subscription) {
        if (res.subscription.hasOwnProperty(property)) {
          this.subscription.push({name: property , value: res.subscription[ property ].count});
        }
      }
      if (res.cooperationCount) {
        this.dataNumber.push({name: 'Cooperation' , value: res.cooperationCount});
        this.cooperationCount = res.cooperationCount;
      }
    });
  }

  getCommunications () {
    this.userService.getCommunicationsDashboardInfo(this.orgId , this.isTime).subscribe((res: any) => {
      this.communication = [];
      for (let property in res.communication) {
        if (res.communication.hasOwnProperty(property)) {
          this.communication.push({name: property , value: res.communication[ property ].count});
        }
      }
    });
  }

  sortData (data) {
    return data.sort((a , b) => {
      if (a.value > b.value) {
        return -1;
      }
      if (a.value < b.value) {
        return 1;
      }
      return 0;
    });
  }

  getData () {
    this.userService.getGeneralDashboardInfo(this.orgId , this.isTime).subscribe((res: any) => {
      this.data = null;
      this.dataTG = [];
      this.dataNumber = [];
      this.dataEventType = [];
      this.dataUsers = [ [] , [] , [] , [] ];
      this.dataEvents = [ [] , [] , [] , [] ];
      this.eventTypeColor = {
        domain: [] , name: 'coolthree' ,
        selectable: true ,
        group: 'Ordinal'
      };
      this.data = res;
      this.dataNumber.push({name: res.event.event.title , value: res.event.event.count});
      this.dataNumber.push({name: 'Users' , value: res.user.male.count + res.user.female.count});
      // this.dataNumber.push({name: res.user.female.title , value: res.user.female.count});
      // this.dataNumber.push({name: res.user.student.title , value: res.user.student.count});
      // this.dataNumber.push({name: res.user.parent.title , value: res.user.parent.count});

      this.dataNumber.push({name: res.user.clan.title , value: res.user.clan.count});
      if (this.cooperationCount !== 0) {
        this.dataNumber.push({name: 'Cooperation' , value: this.cooperationCount});
      }
      if (res.user.country !== 0) {
        this.dataNumber.push({name: 'Country' , value: res.user.country});
      }
      if (res.user.city !== 0) {
        this.dataNumber.push({name: 'SubCountry' , value: res.user.city});
      }
      if (res.user.organization !== 0) {
        this.dataNumber.push({name: 'Organization' , value: res.user.organization});
      }
      if (res.user.student.count !== 0) {
        this.dataUsers[ 0 ].push({name: res.user.student.title , value: res.user.student.count});
      }
      if (res.user.parent.count !== 0) {
        this.dataUsers[ 0 ].push({name: res.user.parent.title , value: res.user.parent.count});
      }
      if (res.user.male.count !== 0) {
        this.dataUsers[ 1 ].push({name: res.user.male.title , value: res.user.male.count});
      }
      if (res.user.female.count !== 0) {
        this.dataUsers[ 1 ].push({name: res.user.female.title , value: res.user.female.count});
      }
      if (res.user.member.count !== 0) {
        this.dataUsers[ 2 ].push({name: res.user.member.title , value: res.user.member.count});
      }
      if (res.user.noMember.count !== 0) {
        this.dataUsers[ 2 ].push({name: res.user.noMember.title , value: res.user.noMember.count});
      }
      if (res.user.active.count !== 0) {
        this.dataUsers[ 3 ].push({name: res.user.active.title , value: res.user.active.count});
      }
      if (res.user.noActive.count !== 0) {
        this.dataUsers[ 3 ].push({name: res.user.noActive.title , value: res.user.noActive.count});
      }


      if (res.event.online.count !== 0) {
        this.dataEvents[ 0 ].push({name: res.event.online.title , value: res.event.online.count});
      }
      if (res.event.offline.count !== 0) {
        this.dataEvents[ 0 ].push({name: res.event.offline.title , value: res.event.offline.count});
      }
      if (res.event.registration.count !== 0) {
        this.dataEvents[ 1 ].push({name: res.event.registration.title , value: res.event.registration.count});
      }
      if (res.event.noRegistration.count !== 0) {
        this.dataEvents[ 1 ].push({name: res.event.noRegistration.title , value: res.event.noRegistration.count});
      }
      if (res.event.merge.count !== 0) {
        this.dataEvents[ 2 ].push({name: res.event.merge.title , value: res.event.merge.count});
      }
      if (res.event.noMerge.count !== 0) {
        this.dataEvents[ 2 ].push({name: res.event.noMerge.title , value: res.event.noMerge.count});
      }
      if (res.event.all.count !== 0) {
        this.dataEvents[ 3 ].push({name: res.event.all.title , value: res.event.all.count});
      }
      if (res.event.male.count !== 0) {
        this.dataEvents[ 3 ].push({name: res.event.male.title , value: res.event.male.count});
      }
      if (res.event.female.count !== 0) {
        this.dataEvents[ 3 ].push({name: res.event.female.title , value: res.event.female.count});
      }

      for (let property in res.user.targetGroups) {
        if (res.user.targetGroups.hasOwnProperty(property)) {
          this.dataTG.push({name: property , value: res.user.targetGroups[ property ]});
        }
      }

      for (let property in res.event.eventLevels) {
        if (res.event.eventLevels.hasOwnProperty(property)) {
          this.dataEventType.push({
            name: property ,
            value: res.event.eventLevels[ property ].count ,
            color: res.event.eventLevels[ property ].color
          });
        }
      }
      this.dataTG = this.sortData(this.dataTG);
      this.dataEventType = this.sortData(this.dataEventType);
      for (let i = 0; i < this.dataEventType.length; i++) {
        this.eventTypeColor.domain.push(this.dataEventType[ i ].color);
      }
    });
  }

  changeTime (event) {
    this.isTime = event;
    this.getData();
    this.getEventsInfo();
    this.getSubscription();
  }
}
